import React from "react";
import { cn } from "../utils";
import { typography } from "../tokens";

export function SectionTitle({ children, action, className }) {
  return (
    <div className={cn("flex items-center justify-between", className)}>
      <h3 className="text-gray-800" style={typography.section}>{children}</h3>
      {action}
    </div>
  );
}

export function SectionHeader({ title, action, className, mb = "mb-4" }) {
  return (
    <SectionTitle className={cn(mb, className)} action={action}>
      {title}
    </SectionTitle>
  );
}
